import {combineReducers} from 'redux';



import {homeReducer} from './containers/home/_reducer'
import {campaignsDetailReducer, campaignsReducer} from './containers/campaigns/_reducer'
import {ordersReducer, ordersDetail, ordersChat, sendChat, sendHasil, taskAssigned, sendEmail} from './containers/orders/_reducer'
import {pesanReducer, createPesan, getPesanDetail, detailReply} from './containers/pesan/_reducer'
import {billingReducer, billingDetailReducer} from './containers/billing/_reducer'
import {
  accountReducer,
  deleteAssets, 
  accountChannels, 
  newsRequest,
  channelsDetail,
  getChannelDetail, 
  accountPortfolio,
  reviewsReplies, 
  accountReviews,
  assetVerify,
  assetVerifyRequest,
  createAssets,
  getLoginToken,
  assetCallback,
  getProfile,
  updateProfile,
  addPortfolio
} from './containers/akun/_reducer'

import {
  contestReducer,
  contestsDetailReducer,
  getGifts,
  getEntries,
  getWinners,
  joinContest,
  discussContest,
  addComments
} from './containers/contest/_reducer';

import {
  articlesReducer,
  articlesCreate,
  articlesOrders,
  articlesOrdersDetail
} from './containers/articles/_reducer';

import {
  awardsReducer,
  awardsRanks,
  awardsPoints,
  awardsHistory
} from './containers/awards/_reducer';

import {getBanks} from './reducers/getBanks'
import { Marital } from './helper/marital';
import { Job } from './helper/job';
import { UserStatus } from './helper/userStatus';

function categoriesReducer(state = {
  categories: []
}, action){
  switch(action.type){
    case 'GET_CATEGORIES_FULFILLED':
      return Object.assign({}, state, {
        categories: action.payload.data.results.categories
      })

    case 'GET_CATEGORIES_CHECKED':
      return Object.assign({}, state, {
        categories: action.categories
      })

    case 'UPDATE_CATEGORIES_CHECKED': {

      let categories = state.categories.map(data => {
        if(data.id === action.payload){
          data.checked = !data.checked
        }
        return data
      })

      return Object.assign({}, state, {
        categories
      })
    }
    default:
      return state
  }
}

function locationsReducer(state = {
  locations: []
}, action){
  switch(action.type){
    case 'GET_LOCATIONS_FULFILLED':
      return Object.assign({}, state, {
        locations: action.payload.data.results.data
      })
    case 'GET_LOCATIONS_CHECKED':
        return Object.assign({}, state, {
          locations: action.data
        })
    default:
      return state
  }
}

function getNotifications(state = {
  badges: {}
}, action){
  switch(action.type){
    case 'GET_NOTIFICATIONS_FULFILLED':
      return Object.assign({}, state, {
        badges: action.payload.data.results.badges
      })
    case 'GET_NOTIFICATIONS_PENDING':
      return Object.assign({}, state, {
        badges: {}
      })
    default:
      return state
  }
}

function genderLocation(state = {
  gender: [
    {
      id: 1,
      name: 'Laki - Laki'
    },
    {
      id: 2,
      name: 'Perempuan'
    },
  ]
}, action){
  switch(action.type){
    default:
      return state
  }
}


function maritalReducer(state = {
  marital: Marital
}, action){
  switch(action.type){
    default:
      return state
  }
}


function jobReducer(state = {
  job: Job
}, action){
  switch(action.type){
    default:
      return state
  }
}

function userStatusReducer(state = {
  UserStatus: UserStatus
}, action){
  switch(action.type){
    default:
      return state
  }
}


const rootReducer = combineReducers({    
  categoriesReducer,
  locationsReducer,
  homeReducer,
  campaignsReducer,
  ordersReducer,
  campaignsDetailReducer,
  ordersDetail,
  ordersChat,
  sendChat,
  sendHasil,
  taskAssigned,
  pesanReducer,
  sendEmail,
  createPesan,
  getPesanDetail,
  detailReply,
  billingReducer,
  billingDetailReducer,
  accountReducer,
  accountChannels,
  channelsDetail,
  accountPortfolio,
  getBanks,
  accountReviews,
  reviewsReplies,
  getChannelDetail,
  newsRequest,
  deleteAssets,
  assetVerify,
  assetVerifyRequest,
  createAssets,
  getLoginToken,
  assetCallback,
  getProfile,
  updateProfile,
  genderLocation,
  maritalReducer,
  jobReducer,
  userStatusReducer,
  addPortfolio,
  contestReducer,
  contestsDetailReducer,
  getGifts,
  getEntries,
  getWinners,
  joinContest,
  discussContest,
  addComments,
  articlesReducer,
  articlesCreate,
  articlesOrders,
  awardsReducer,
  articlesOrdersDetail,
  awardsRanks,
  awardsPoints,
  getNotifications,
  awardsHistory
})


export default rootReducer;